import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Index from '../views/index.vue'



const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Index,
    
  },
  {path: '/overtones', component: () => import('@/views/OvertonesPage.vue')},
  {path: '/play-sound', component: () => import('@/views/PlaySound.vue')},
  {path: '/wave', component: () => import('@/views/Wave.vue')},

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
